import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { GlobalContext } from 'components/context'
import { options, result, routes } from 'components/context/api'
import fetch from 'fetch'

const operator = process.env.REACT_APP_OPERATOR

const VippsCallback = () => {
  const { t } = useContext(GlobalContext)
  const [error, setError] = useState(null)

  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const state = params.get('state')

  useEffect(() => {
    if (!code || !state) {
      setError('missing_params')
      return
    }

    const opts = options({
      method: 'POST',
      body: {
        operator_id: operator,
        code,
        state,
        redirect_uri: `${window.location.origin}/vipps/callback`,
      },
    })

    fetch(routes.vippsCallback, opts)
      .then(res => result(res))
      .then(data => {
        localStorage.setItem('token', data.token)
        window.location.href = '/'
      })
      .catch(err => {
        if (err.status === 404) {
          setError('no_membership')
        } else {
          setError('default')
        }
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    const tKey = error === 'missing_params' ? 'default' : error
    return (
      <div className={'container'}>
        <div className={'error'}>
          {t(`forms.login.vipps_error.${tKey}`)}
        </div>
        <Link to={'/'}>
          {t('forms.login.button')}
        </Link>
      </div>
    )
  }

  return (
    <div className={'container'}>
      <p>{t('forms.login.vipps_loading')}</p>
    </div>
  )
}

export default VippsCallback
